export const SocialLinks = [
    {
        key: 0,
        openLink: "https://www.github.com/im-minion",
        imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
        displayText: "im-minion"
    },
    {
        key: 1,
        openLink: "https://www.linkedin.com/in/vaibhav-miniyar-98966b126",
        imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/LinkedIN_black.png?raw=true",
        displayText: "vaibhav-miniyar"
    },
    {
        key: 2,
        openLink: "https://stackoverflow.com/users/6810226/vaibhav-miniyar",
        imageUrl: "data:image/png;base64,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",
        displayText: "vaibhav-miniyar"
    },
//     {
//         key: 3,
//         openLink: "https://www.instagram.com/im.minion",
//         imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Instagram_black.png?raw=true",
//         displayText: "im-minion"
//     },
    {
        key: 4,
        openLink: "https://twitter.com/vaibhavminion",
        imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Twitter_black.png?raw=true",
        displayText: "vaibhav-minion"
    },
];

export const Projects = [
    {
        key: 0,
        title: "Referral Portal",
        description: "Referral Portal is a portal that can be used within an organization for Hiring purpose. It has Separate login and consoles for Employee, Hiring Managers, HR and Admin to keep track of applicants and manage them used Spring Security to deal with role-based Authentication and Authorization.",
        exploreLinks: [
            {
                key: 0,
                openLink: "https://im-minion.github.io/ReferralPortalWeb",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Webpage"
            },
            {
                key: 1,
                openLink: "https://github.com/im-minion/ReferralPortalWeb",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Frontend"
            },
            {
                key: 2,
                openLink: "https://github.com/im-minion/ReferralPortalServices",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Backend"
            }
        ],
        technologies: [
            {
                key: 0,
                openLink: "https://spring.io/",
                imageUrl: "https://blog.frankel.ch/assets/resources/more-devops-for-spring-boot/spring-boot-logo.svg",
                displayText: "Spring Boot"
            },
            {
                key: 1,
                openLink: "https://angular.io/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands-1/512/21_Angular_logo_logos-512.png",
                displayText: "Angular 10"
            },
            {
                key: 2,
                openLink: "https://www.mongodb.com/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/mongodb-512.png",
                displayText: "MongoDB"
            }
        ]
    },
    {
        key: 1,
        title: "Folio",
        description: "Folio is a social networking platform to explore people and their the projects. You can also connect with them and explore their other social networking platforms. It's  a kind of virtual visiting card.",
        exploreLinks: [
            {
                key: 0,
                openLink: "https://github.com/projectFolio",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Code"
            },
            {
                key: 1,
                openLink: "https://myfolio.vercel.app/",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Website"
            }
        ],
        technologies: [
            {
                key: 0,
                openLink: "https://spring.io/",
                imageUrl: "https://blog.frankel.ch/assets/resources/more-devops-for-spring-boot/spring-boot-logo.svg",
                displayText: "Spring Boot"
            },
            {
                key: 1,
                openLink: "https://angular.io/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands-1/512/21_Angular_logo_logos-512.png",
                displayText: "Angular 10"
            },
            {
                key: 2,
                openLink: "https://www.mongodb.com/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/mongodb-512.png",
                displayText: "MongoDB"
            }
        ]
    },
    {
        key: 2,
        title: "Subjective Answer Evaluation using Machine Learning",
        description: "A basic Machine learning app to evaluate the subjective/descriptive answers based on model answer is provided. It basically uses Keywords, Grammar and Question Specific Things(QST) along with Semantic meaning. Using NB classifier gives the score.",
        exploreLinks: [
            {
                key: 0,
                openLink: "https://github.com/im-minion/Subjective-Answer-Evaluation",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Code"
            }
        ],
        technologies: [
            {
                key: 0,
                openLink: "https://www.python.org/",
                imageUrl: "https://banner2.cleanpng.com/20180515/bkw/kisspng-computer-icons-python-5afac9ee46b749.8768191615263851342897.jpg",
                displayText: "Python"
            },
            {
                key: 1,
                openLink: "https://tensorflow.io/",
                imageUrl: "https://friconix.com/png/fi-xnsuxx-tensorflow.png",
                displayText: "TensorFlow"
            },
            {
                key: 2,
                openLink: "https://firebase.google.com/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/firebase-512.png",
                displayText: "Firebase"
            }
        ]
    },
    {
        key: 3,
        title: "Blog Application",
        description: "A Blog Application made using flutter and Firebase. User can login and post the blogs which is visible to all other users.",
        exploreLinks: [
            {
                key: 0,
                openLink: "https://github.com/im-minion/Flutter-Blog-App-Firebase",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Code"
            }
        ],
        technologies: [
            {
                key: 0,
                openLink: "https://www.flutter.io/",
                imageUrl: "https://img.icons8.com/ios/452/flutter.png",
                displayText: "Flutter"
            },
            {
                key: 1,
                openLink: "https://firebase.google.com/",
                imageUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/firebase-512.png",
                displayText: "Firebase"
            }
        ]
    },
    {
        key: 4,
        title: "Stars Game",
        description: "A game of Counting Stars made with react. User has to select the number of stars appearing and click on the respective button. User can press the button of exact count of stars or multiple buttons which sums to the stars appearing in 10 sec.",
        exploreLinks: [
            {
                key: 0,
                openLink: "https://github.com/im-minion/stars-game-react",
                imageUrl: "https://github.com/gauravghongde/social-icons/blob/master/PNG/Black/Github_black.png?raw=true",
                displayText: "Code"
            },
            {
                key: 1,
                openLink: "https://im-minion.github.io/stars-game-react/",
                imageUrl: "https://e7.pngegg.com/pngimages/43/934/png-clipart-computer-icons-google-play-android-angle-triangle.png",
                displayText: "Play"
            }
        ],
        technologies: [
            {
                key: 0,
                openLink: "https://reactjs.org/",
                imageUrl: "https://p1.hiclipart.com/preview/196/853/315/react-logo-javascript-stack-overflow-front-and-back-ends-github-freecodecamp-redux-computer-software-png-clipart.jpg",
                displayText: "React"
            }
        ]
    }
];

export const Skills = [
    {
        key: 0,
        icon : "https://mpng.subpng.com/20180528/xc/kisspng-java-platform-enterprise-edition-computer-program-java-5b0bf9a56ea501.5862886015275114614532.jpg",
        title: "Java 8"
    },
    {
        key: 1,
        icon: "https://cdn4.iconfinder.com/data/icons/logos-and-brands-1/512/21_Angular_logo_logos-512.png",
        title: "Angular 2+"
    },
    {
        key: 2,
        icon: "https://blog.frankel.ch/assets/resources/more-devops-for-spring-boot/spring-boot-logo.svg",
        title: "Spring Boot"
    },
    {
        key: 3,
        icon: "https://blog.frankel.ch/assets/resources/more-devops-for-spring-boot/spring-boot-logo.svg",
        title: "Spring Security"
    },
    {
        key: 4,
        icon:"https://p1.hiclipart.com/preview/196/853/315/react-logo-javascript-stack-overflow-front-and-back-ends-github-freecodecamp-redux-computer-software-png-clipart.jpg",
        title: "React"
    },
    {
        key: 5,
        icon: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_1280.png",
        title: "HTML"
    },
    {
        key: 6,
        icon: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_1280.png",
        title: "CSS"
    },
]
